"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proximaNovaExtrabold = exports.proximaNova = exports.montserrat = exports.fontSizes = exports.fontFaces = exports.customFont = exports.EMAIL_SAFE_FONTS = void 0;
var _styledComponents = require("styled-components");
var fontSizes = exports.fontSizes = {
  s56: '56px',
  s48: '48px',
  s40: '40px',
  s36: '36px',
  s32: '32px',
  s24: '24px',
  s22: '22px',
  s20: '20px',
  s18: '18px',
  s16: '16px',
  s14: '14px',
  s12: '12px',
  s11: '11px',
  s10: '10px'
};
var fontFaces = exports.fontFaces = (0, _styledComponents.css)(["@font-face{font-family:'ProximaNova';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.eot');src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.eot?#iefix') format('embedded-opentype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.woff') format('woff'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.ttf') format('truetype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_1_0.svg#wf') format('svg');font-weight:300;}@font-face{font-family:'ProximaNova';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.eot');src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.eot?#iefix') format('embedded-opentype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.woff') format('woff'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.ttf') format('truetype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.svg#wf') format('svg');font-weight:normal;}@font-face{font-family:'ProximaNova';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.eot');src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.eot?#iefix') format('embedded-opentype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.woff') format('woff'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.ttf') format('truetype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_2_0.svg#wf') format('svg');font-weight:600;font-style:normal;font-stretch:normal;}@font-face{font-family:'ProximaNova';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.eot');src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.eot?#iefix') format('embedded-opentype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.woff') format('woff'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.ttf') format('truetype'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_5_0.svg#wf') format('svg');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:'Montserrat';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/montserrat/montserrat-extrabold-webfont.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/montserrat/montserrat-extrabold-webfont.woff') format('woff');font-weight:800;font-style:normal;font-display:fallback;}@font-face{font-family:'Montserrat';src:url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/montserrat/montserrat-semibold-webfont.woff2') format('woff2'),url('https://d25purrcgqtc5w.cloudfront.net/dist/fonts/montserrat/montserrat-semibold-webfont.woff') format('woff');font-weight:600;font-style:normal;font-display:fallback;}"]);
var proximaNova = exports.proximaNova = 'ProximaNova, Arial, sans-serif';
// TODO: implement font-face
var proximaNovaExtrabold = exports.proximaNovaExtrabold = 'ProximaNova-Extrabold';
var montserrat = exports.montserrat = 'Montserrat';

/*
    Custom Font Options
*/
var customFont = exports.customFont = {
  Abel: {
    font_type: 'Abel',
    font_url: 'https://fonts.googleapis.com/css?family=Abel',
    font_family: "'Abel', sans-serif"
  },
  'Abril Fatface': {
    font_type: 'Abril Fatface',
    font_url: 'https://fonts.googleapis.com/css?family=Abril+Fatface',
    font_family: "'Abril Fatface', cursive"
  },
  Alegreya: {
    font_type: 'Alegreya',
    font_url: 'https://fonts.googleapis.com/css2?family=Alegreya',
    font_family: "'Alegreya', serif"
  },
  'Amatic SC': {
    font_type: 'Amatic SC',
    font_url: 'https://fonts.googleapis.com/css2?family=Amatic+SC',
    font_family: "'Amatic SC', sans-serif"
  },
  Anton: {
    font_type: 'Anton',
    font_url: 'https://fonts.googleapis.com/css2?family=Anton',
    font_family: "'Anton', sans-serif"
  },
  Arapey: {
    font_type: 'Arapey',
    font_url: 'https://fonts.googleapis.com/css2?family=Arapey',
    font_family: "'Arapey', serif"
  },
  Arial: {
    font_type: 'Arial',
    font_family: 'Arial, sans-serif'
  },
  'Arial Black': {
    font_type: 'Arial Black',
    font_family: "'Arial Black', sans-serif"
  },
  Arvo: {
    font_type: 'Arvo',
    font_url: 'https://fonts.googleapis.com/css?family=Arvo',
    font_family: "'Arvo', serif"
  },
  Audiowide: {
    font_type: 'Audiowide',
    font_url: 'https://fonts.googleapis.com/css2?family=Audiowide',
    font_family: "'Audiowide', cursive"
  },
  'Averia Serif Libre': {
    font_type: 'Averia Serif Libre',
    font_url: 'https://fonts.googleapis.com/css2?family=Averia+Serif+Libre',
    font_family: "'Averia Serif Libre', serif"
  },
  Baloo: {
    font_type: 'Baloo',
    font_url: 'https://fonts.googleapis.com/css?family=Baloo',
    font_family: "'Baloo', cursive"
  },
  'Bebas Neue': {
    font_type: 'Bebas Neue',
    font_url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue',
    font_family: "'Bebas Neue', sans-serif"
  },
  Bitter: {
    font_type: 'Bitter',
    font_url: 'https://fonts.googleapis.com/css2?family=Bitter',
    font_family: "'Bitter', serif"
  },
  'Bodoni Moda': {
    font_type: 'Bodoni Moda',
    font_url: 'https://fonts.googleapis.com/css?family=Bodoni+Moda',
    font_family: "'Bodoni Moda', serif"
  },
  'Bree Serif': {
    font_type: 'Bree Serif',
    font_url: 'https://fonts.googleapis.com/css?family=Bree+Serif',
    font_family: "'Bree Serif', serif"
  },
  'Brush Script MT': {
    font_type: 'Brush Script MT',
    font_family: "'Brush Script MT', cursive"
  },
  Cardo: {
    font_type: 'Cardo',
    font_url: 'https://fonts.googleapis.com/css2?family=Cardo',
    font_family: "'Cardo', serif"
  },
  Caveat: {
    font_type: 'Caveat',
    font_url: 'https://fonts.googleapis.com/css?family=Caveat',
    font_family: "'Caveat', cursive"
  },
  Chivo: {
    font_type: 'Chivo',
    font_url: 'https://fonts.googleapis.com/css2?family=Chivo',
    font_family: "'Chivo', sans-serif"
  },
  Cinzel: {
    font_type: 'Cinzel',
    font_url: 'https://fonts.googleapis.com/css2?family=Cinzel',
    font_family: "'Cinzel', serif"
  },
  Comfortaa: {
    font_type: 'Comfortaa',
    font_url: 'https://fonts.googleapis.com/css?family=Comfortaa',
    font_family: "'Comfortaa', cursive"
  },
  'Concert One': {
    font_type: 'Concert One',
    font_url: 'https://fonts.googleapis.com/css?family=Concert+One',
    font_family: "'Concert One', cursive"
  },
  Cookie: {
    font_type: 'Cookie',
    font_url: 'https://fonts.googleapis.com/css2?family=Cookie',
    font_family: "'Cookie', cursive"
  },
  Corben: {
    font_type: 'Corben',
    font_url: 'https://fonts.googleapis.com/css?family=Corben',
    font_family: "'Corben', cursive"
  },
  'Cormorant Garamond': {
    font_type: 'Cormorant Garamond',
    font_url: 'https://fonts.googleapis.com/css?family=Cormorant+Garamond',
    font_family: "'Cormorant Garamond', serif"
  },
  Courgette: {
    font_type: 'Courgette',
    font_url: 'https://fonts.googleapis.com/css?family=Courgette',
    font_family: "'Courgette', cursive"
  },
  'Crimson Text': {
    font_type: 'Crimson Text',
    font_url: 'https://fonts.googleapis.com/css2?family=Crimson+Text',
    font_family: "'Crimson Text', serif"
  },
  'Cutive Mono': {
    font_type: 'Cutive Mono',
    font_url: 'https://fonts.googleapis.com/css?family=Cutive+Mono',
    font_family: "'Cutive Mono', monospace"
  },
  'Courier New': {
    font_type: 'Courier New',
    font_family: "'Courier New', monospace"
  },
  'Dancing Script': {
    font_type: 'Dancing Script',
    font_url: 'https://fonts.googleapis.com/css?family=Dancing+Script',
    font_family: "'Dancing Script', cursive"
  },
  'Dawning of A New Day': {
    font_type: 'Dawning of A New Day',
    font_url: 'https://fonts.googleapis.com/css?family=Dawning+of+a+New+Day',
    font_family: "'Dawning of A New Day', cursive"
  },
  'DM Sans': {
    font_type: 'DM Sans',
    font_url: 'https://fonts.googleapis.com/css2?family=DM+Sans',
    font_family: "'DM Sans', sans-serif"
  },
  'DM Serif Display': {
    font_type: 'DM Serif Display',
    font_url: 'https://fonts.googleapis.com/css2?family=DM+Serif+Display',
    font_family: "'DM Serif Display', serif"
  },
  Dosis: {
    font_type: 'Dosis',
    font_url: 'https://fonts.googleapis.com/css?family=Dosis',
    font_family: "'Dosis', sans-serif"
  },
  'Droid Serif': {
    font_type: 'Droid Serif',
    font_url: 'https://fonts.googleapis.com/css?family=Droid+Serif',
    font_family: "'Droid Serif', serif"
  },
  'EB Garamond': {
    font_type: 'EB Garamond',
    font_url: 'https://fonts.googleapis.com/css2?family=EB+Garamond',
    font_family: "'EB Garamond', serif"
  },
  Elsie: {
    font_type: 'Elsie',
    font_url: 'https://fonts.googleapis.com/css?family=Elsie',
    font_family: "'Elsie', cursive"
  },
  'Frank Ruhl Libre': {
    font_type: 'Frank Ruhl Libre',
    font_url: 'https://fonts.googleapis.com/css?family=Frank+Ruhl+Libre',
    font_family: "'Frank Ruhl Libre', serif"
  },
  'Fugaz One': {
    font_type: 'Fugaz One',
    font_url: 'https://fonts.googleapis.com/css?family=Fugaz+One',
    font_family: "'Fugaz One', cursive"
  },
  Georgia: {
    font_type: 'Georgia',
    font_family: 'Georgia, serif'
  },
  'Great Vibes': {
    font_type: 'Great Vibes',
    font_url: 'https://fonts.googleapis.com/css?family=Great+Vibes',
    font_family: "'Great Vibes', cursive"
  },
  Helvetica: {
    font_type: 'Helvetica',
    font_family: 'Helvetica, sans-serif'
  },
  Inconsolata: {
    font_type: 'Inconsolata',
    font_url: 'https://fonts.googleapis.com/css?family=Inconsolata',
    font_family: "'Inconsolata', monospace"
  },
  Inter: {
    font_type: 'Inter',
    font_url: 'https://fonts.googleapis.com/css2?family=Inter',
    font_family: "'Inter', sans-serif"
  },
  Italiana: {
    font_type: 'Italiana',
    font_url: 'https://fonts.googleapis.com/css2?family=Italiana',
    font_family: "'Italiana', serif"
  },
  'Josefin Sans': {
    font_type: 'Josefin Sans',
    font_url: 'https://fonts.googleapis.com/css?family=Josefin+Sans',
    font_family: "'Josefin Sans', sans-serif"
  },
  'Josefin Slab': {
    font_type: 'Josefin Slab',
    font_url: 'https://fonts.googleapis.com/css2?family=Josefin+Slab',
    font_family: "'Josefin Slab', serif"
  },
  Jost: {
    font_type: 'Jost',
    font_url: 'https://fonts.googleapis.com/css2?family=Jost',
    font_family: "'Jost', sans-serif"
  },
  'Kaushan Script': {
    font_type: 'Kaushan Script',
    font_url: 'https://fonts.googleapis.com/css?family=Kaushan+Script',
    font_family: "'Kaushan Script', cursive"
  },
  Knewave: {
    font_type: 'Knewave',
    font_url: 'https://fonts.googleapis.com/css?family=Knewave',
    font_family: "'Knewave', cursive"
  },
  Kristi: {
    font_type: 'Kristi',
    font_url: 'https://fonts.googleapis.com/css?family=Kristi',
    font_family: "'Kristi', cursive"
  },
  Lato: {
    font_type: 'Lato',
    font_url: 'https://fonts.googleapis.com/css?family=Lato',
    font_family: "'Lato', sans-serif"
  },
  'Lexend Giga': {
    font_type: 'Lexend Giga',
    font_url: 'https://fonts.googleapis.com/css2?family=Lexend+Giga',
    font_family: "'Lexend Giga', sans-serif"
  },
  'Libre Baskerville': {
    font_type: 'Libre Baskerville',
    font_url: 'https://fonts.googleapis.com/css?family=Libre+Baskerville',
    font_family: "'Libre Baskerville', serif"
  },
  'Lily Script One': {
    font_type: 'Lily Script One',
    font_url: 'https://fonts.googleapis.com/css?family=Lily+Script+One',
    font_family: "'Lily Script One', cursive"
  },
  Lobster: {
    font_type: 'Lobster',
    font_url: 'https://fonts.googleapis.com/css?family=Lobster',
    font_family: "'Lobster', cursive"
  },
  Lora: {
    font_type: 'Lora',
    font_url: 'https://fonts.googleapis.com/css?family=Lora',
    font_family: "'Lora', serif"
  },
  'Lucida Console': {
    font_type: 'Lucida Console',
    font_family: "'Lucida Console', monospace"
  },
  Marcellus: {
    font_type: 'Marcellus',
    font_url: 'https://fonts.googleapis.com/css2?family=Marcellus',
    font_family: "'Marcellus', serif"
  },
  'Marck Script': {
    font_type: 'Marck Script',
    font_url: 'https://fonts.googleapis.com/css2?family=Marck+Script',
    font_family: "'Marck Script', cursive"
  },
  Manrope: {
    font_type: 'Manrope',
    font_url: 'https://fonts.googleapis.com/css2?family=Manrope',
    font_family: "'Manrope', sans-serif"
  },
  Merriweather: {
    font_type: 'Merriweather',
    font_url: 'https://fonts.googleapis.com/css?family=Merriweather',
    font_family: "'Merriweather', serif"
  },
  Monaco: {
    font_type: 'Monaco',
    font_family: 'Monaco, monospace'
  },
  Montserrat: {
    font_type: 'Montserrat',
    font_url: 'https://fonts.googleapis.com/css?family=Montserrat',
    font_family: "'Montserrat', sans-serif"
  },
  'Mr Dafoe': {
    font_type: 'Mr Dafoe',
    font_url: 'https://fonts.googleapis.com/css?family=Mr+Dafoe',
    font_family: "'Mr Dafoe', cursive"
  },
  'Mr De Haviland': {
    font_type: 'Mr De Haviland',
    font_url: 'https://fonts.googleapis.com/css?family=Mr+De+Haviland',
    font_family: "'Mr De Haviland', cursive"
  },
  'Mrs Saint Delafield': {
    font_type: 'Mrs Saint Delafield',
    font_url: 'https://fonts.googleapis.com/css?family=Mrs+Saint+Delafield',
    font_family: "'Mrs Saint Delafield', cursive"
  },
  Monoton: {
    font_type: 'Monoton',
    font_url: 'https://fonts.googleapis.com/css2?family=Monoton',
    font_family: "'Monoton', cursive"
  },
  'Mrs Sheppards': {
    font_type: 'Mrs Sheppards',
    font_url: 'https://fonts.googleapis.com/css?family=Mrs+Sheppards',
    font_family: "'Mrs Sheppards', cursive"
  },
  Newsreader: {
    font_type: 'Newsreader',
    font_url: 'https://fonts.googleapis.com/css2?family=Newsreader',
    font_family: "'Newsreader', serif"
  },
  'Noto Sans': {
    font_type: 'Noto Sans',
    font_url: 'https://fonts.googleapis.com/css2?family=Noto+Sans',
    font_family: "'Noto Sans', sans-serif"
  },
  'Noto Serif': {
    font_type: 'Noto Serif',
    font_url: 'https://fonts.googleapis.com/css2?family=Noto+Serif',
    font_family: "'Noto Serif', serif"
  },
  'Noto Serif Display': {
    font_type: 'Noto Serif Display',
    font_url: 'https://fonts.googleapis.com/css2?family=Noto+Serif+Display',
    font_family: "'Noto Serif Display', serif"
  },
  Nunito: {
    font_type: 'Nunito',
    font_url: 'https://fonts.googleapis.com/css?family=Nunito',
    font_family: "'Nunito', sans-serif"
  },
  'Oooh Baby': {
    font_type: 'Oooh Baby',
    font_url: 'https://fonts.googleapis.com/css?family=Oooh+Baby',
    font_family: "'Oooh Baby', cursive"
  },
  'Open Sans': {
    font_type: 'Open Sans',
    font_url: 'https://fonts.googleapis.com/css?family=Open+Sans',
    font_family: "'Open Sans', sans-serif"
  },
  'Open Sans Condensed': {
    font_type: 'Open Sans Condensed',
    font_url: 'https://fonts.googleapis.com/css?family=Open+Sans+Condensed',
    font_family: "'Open Sans Condensed', sans-serif"
  },
  Oswald: {
    font_type: 'Oswald',
    font_url: 'https://fonts.googleapis.com/css?family=Oswald',
    font_family: "'Oswald', sans-serif"
  },
  Oxygen: {
    font_type: 'Oxygen',
    font_url: 'https://fonts.googleapis.com/css?family=Oxygen',
    font_family: "'Oxygen', sans-serif"
  },
  'Patrick Hand': {
    font_type: 'Patrick Hand',
    font_url: 'https://fonts.googleapis.com/css2?family=Patrick+Hand',
    font_family: "'Patrick Hand', cursive"
  },
  Parisienne: {
    font_type: 'Parisienne',
    font_url: 'https://fonts.googleapis.com/css?family=Parisienne',
    font_family: "'Parisienne', cursive"
  },
  'Pinyon Script': {
    font_type: 'Pinyon Script',
    font_url: 'https://fonts.googleapis.com/css2?family=Pinyon+Script',
    font_family: "'Pinyon Script', cursive"
  },
  'Playfair Display': {
    font_type: 'Playfair Display',
    font_url: 'https://fonts.googleapis.com/css?family=Playfair+Display',
    font_family: "'Playfair Display', serif"
  },
  'Permanent Marker': {
    font_type: 'Permanent Marker',
    font_url: 'https://fonts.googleapis.com/css2?family=Permanent+Marker',
    font_family: "'Permanent Marker', cursive"
  },
  Poppins: {
    font_type: 'Poppins',
    font_url: 'https://fonts.googleapis.com/css2?family=Poppins',
    font_family: "'Poppins', sans-serif"
  },
  Prompt: {
    font_type: 'Prompt',
    font_url: 'https://fonts.googleapis.com/css2?family=Prompt',
    font_family: "'Prompt', sans-serif"
  },
  ProximaNova: {
    font_type: 'ProximaNova',
    font_url: 'https://d25purrcgqtc5w.cloudfront.net/dist/fonts/proximanova/302D42_4_0.eot',
    font_family: "'ProximaNova', Arial, sans-serif"
  },
  'PT Sans': {
    font_type: 'PT Sans',
    font_url: 'https://fonts.googleapis.com/css?family=PT+Sans',
    font_family: "'PT Sans', sans-serif"
  },
  'PT Sans Narrow': {
    font_type: 'PT Sans Narrow',
    font_url: 'https://fonts.googleapis.com/css?family=PT+Sans+Narrow',
    font_family: "'PT Sans Narrow', sans-serif"
  },
  'PT Serif': {
    font_type: 'PT Serif',
    font_url: 'https://fonts.googleapis.com/css2?family=PT+Serif',
    font_family: "'PT Serif', serif"
  },
  Quattrocento: {
    font_type: 'Quattrocento',
    font_url: 'https://fonts.googleapis.com/css2?family=Quattrocento',
    font_family: "'Quattrocento', serif"
  },
  Questrial: {
    font_type: 'Questrial',
    font_url: 'https://fonts.googleapis.com/css?family=Questrial',
    font_family: "'Questrial', sans-serif"
  },
  Quicksand: {
    font_type: 'Quicksand',
    font_url: 'https://fonts.googleapis.com/css?family=Quicksand',
    font_family: "'Quicksand', sans-serif"
  },
  Raleway: {
    font_type: 'Raleway',
    font_url: 'https://fonts.googleapis.com/css?family=Raleway',
    font_family: "'Raleway', sans-serif"
  },
  Roboto: {
    font_type: 'Roboto',
    font_url: 'https://fonts.googleapis.com/css?family=Roboto',
    font_family: "'Roboto', sans-serif"
  },
  'Roboto Condensed': {
    font_type: 'Roboto Condensed',
    font_url: 'https://fonts.googleapis.com/css2?family=Roboto+Condensed',
    font_family: "'Roboto Condensed', sans-serif"
  },
  'Roboto Slab': {
    font_type: 'Roboto Slab',
    font_url: 'https://fonts.googleapis.com/css?family=Roboto+Slab',
    font_family: "'Roboto Slab', serif"
  },
  Rubik: {
    font_type: 'Rubik',
    font_url: 'https://fonts.googleapis.com/css2?family=Rubik',
    font_family: "'Rubik', sans-serif"
  },
  Satisfy: {
    font_type: 'Satisfy',
    font_url: 'https://fonts.googleapis.com/css?family=Satisfy',
    font_family: "'Satisfy', cursive"
  },
  Sacramento: {
    font_type: 'Sacramento',
    font_url: 'https://fonts.googleapis.com/css2?family=Sacramento',
    font_family: "'Sacramento', cursive"
  },
  Sail: {
    font_type: 'Sail',
    font_url: 'https://fonts.googleapis.com/css2?family=Sail',
    font_family: "'Sail', system-ui"
  },
  Sanchez: {
    font_type: 'Sanchez',
    font_url: 'https://fonts.googleapis.com/css2?family=Sanchez',
    font_family: "'Sanchez', serif"
  },
  Slabo: {
    font_type: 'Slabo',
    font_url: 'https://fonts.googleapis.com/css?family=Slabo+13px',
    font_family: "'Slabo 13px', serif"
  },
  'Source Sans Pro': {
    font_type: 'Source Sans Pro',
    font_url: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro',
    font_family: "'Source Sans Pro', sans-serif"
  },
  'Special Elite': {
    font_type: 'Special Elite',
    font_url: 'https://fonts.googleapis.com/css?family=Special+Elite',
    font_family: "'Special Elite', cursive"
  },
  Spectral: {
    font_type: 'Spectral',
    font_url: 'https://fonts.googleapis.com/css?family=Spectral',
    font_family: "'Spectral', serif"
  },
  Syne: {
    font_type: 'Syne',
    font_url: 'https://fonts.googleapis.com/css2?family=Syne',
    font_family: "'Syne', sans-serif"
  },
  Tahoma: {
    font_type: 'Tahoma',
    font_family: 'Tahoma, sans-serif'
  },
  'Tenor Sans': {
    font_type: 'Tenor Sans',
    font_url: 'https://fonts.googleapis.com/css2?family=Tenor+Sans',
    font_family: "'Tenor Sans', sans-serif"
  },
  'Times New Roman': {
    font_type: 'Times New Roman',
    font_family: 'Times New Roman, serif'
  },
  'Titillium Web': {
    font_type: 'Titillium Web',
    font_url: 'https://fonts.googleapis.com/css2?family=Titillium+Web',
    font_family: "'Titillium Web', sans-serif"
  },
  'Trebuchet MS': {
    font_type: 'Trebuchet MS',
    font_family: 'Trebuchet MS, sans-serif'
  },
  Ubunto: {
    font_type: 'Ubunto',
    font_url: 'https://fonts.googleapis.com/css2?family=Ubuntu',
    font_family: "'Ubunto', sans-serif"
  },
  Urbanist: {
    font_type: 'Urbanist',
    font_url: 'https://fonts.googleapis.com/css2?family=Urbanist',
    font_family: "'Urbanist', sans-serif"
  },
  Verdana: {
    font_type: 'Verdana',
    font_family: 'Verdana, sans-serif'
  },
  'Work Sans': {
    font_type: 'Work Sans',
    font_url: 'https://fonts.googleapis.com/css2?family=Work+Sans',
    font_family: "'Work Sans', sans-serif"
  },
  'Yeseva One': {
    font_type: 'Yeseva One',
    font_url: 'https://fonts.googleapis.com/css2?family=Yeseva+One',
    font_family: "'Yeseva One', cursive"
  }
};
var EMAIL_SAFE_FONTS = exports.EMAIL_SAFE_FONTS = ['Arial, Helvetica, sans-serif', 'Courier New', 'Georgia', 'Helvetica, Arial, sans-serif', 'Impact', 'Lucida Grande', 'Times New Roman', 'Tahoma', 'Trebuchet MS', 'Verdana'];
//# sourceMappingURL=fonts.js.map